/* ============================================================
   KOVOSIS — product & collection page behaviour
   Variant picker, gallery, qty stepper, delivery countdown,
   buy-now, wishlist toggle, collection filter auto-submit.
   The Ajax add-to-cart + drawer live in kovosis.js (global form interceptor).
   ============================================================ */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function money(cents) {
    var fmt = window.KovosisMoneyFormat || '€{{amount}}';
    var a = fmt.indexOf('{{'), b = fmt.indexOf('}}');
    var token = (a !== -1 && b > a) ? fmt.slice(a + 2, b).trim() : 'amount';
    var dec = (token.indexOf('no_decimals') !== -1) ? 0 : 2;
    var thou = ',', deci = '.';
    if (token.indexOf('comma_separator') !== -1) { thou = '.'; deci = ','; }
    else if (token.indexOf('space_separator') !== -1) { thou = ' '; deci = ','; }
    else if (token.indexOf('apostrophe_separator') !== -1) { thou = "'"; deci = '.'; }
    var parts = (cents / 100).toFixed(dec).split('.');
    var intp = parts[0], grouped = '', c = 0;
    for (var i = intp.length - 1; i >= 0; i--) { grouped = intp.charAt(i) + grouped; c++; if (c % 3 === 0 && i > 0) grouped = thou + grouped; }
    var out = parts[1] != null ? grouped + deci + parts[1] : grouped;
    var str = (a !== -1 && b > a) ? fmt.slice(0, a) + out + fmt.slice(b + 2) : out;
    if (str.indexOf('<') !== -1 || str.indexOf('&') !== -1) {
      var d = document.createElement('div'); d.innerHTML = str; return (d.textContent || '').trim();
    }
    return str;
  }

  /* ---------- gallery ---------- */
  function initGallery(pdp) {
    var main = $('#kov-gal-img', pdp);
    if (!main) return;
    $$('.kov-gal-thumb', pdp).forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) { main.removeAttribute('srcset'); main.src = full; }
        $$('.kov-gal-thumb', pdp).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- variant picker ---------- */
  function initVariants(pdp) {
    var dataEl = document.querySelector('[data-kov-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = $('#kov-variant-id', pdp);
    var optButtons = $$('.kov-js-opt', pdp);
    if (!optButtons.length) return; // single-variant product, nothing to pick

    function selectedValues() {
      var vals = [];
      $$('.kov-opt', pdp).forEach(function (group) {
        var pos = parseInt(group.getAttribute('data-option-position'), 10);
        var active = group.querySelector('.kov-js-opt.is-active');
        vals[pos - 1] = active ? active.getAttribute('data-value') : null;
      });
      return vals;
    }

    function findVariant(vals) {
      return variants.find(function (v) {
        return (v.options || []).every(function (o, i) { return o === vals[i]; });
      });
    }

    function apply(variant) {
      var price = $('#kov-price', pdp), compare = $('#kov-compare', pdp), save = $('#kov-save', pdp);
      var addBtn = $('#kov-add', pdp), addText = $('#kov-add-text', pdp), main = $('#kov-gal-img', pdp);
      var buy = $('.kov-js-buynow', pdp);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (buy) buy.disabled = true;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = money(variant.compare_at_price); compare.hidden = false;
          if (save) { save.textContent = 'Save ' + money(variant.compare_at_price - variant.price); save.hidden = false; }
        } else { compare.hidden = true; if (save) save.hidden = true; }
      }
      if (addBtn && addText) {
        addBtn.disabled = !variant.available;
        addText.textContent = variant.available ? (window.__kovAddLabel || 'Add to basket') : 'Sold out';
      }
      if (buy) buy.disabled = !variant.available;
      if (main && variant.featured_image && variant.featured_image.src) {
        main.removeAttribute('srcset'); main.src = variant.featured_image.src;
        var mid = variant.featured_image.id ? String(variant.featured_image.id) : '';
        $$('.kov-gal-thumb', pdp).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === mid); });
      }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); window.history.replaceState({}, '', u); } catch (e) {}
    }

    // capture the initial add label so we can restore it
    var addText0 = $('#kov-add-text', pdp);
    window.__kovAddLabel = addText0 ? addText0.textContent.trim() : 'Add to basket';

    optButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-position');
        var group = btn.closest('.kov-opt');
        $$('.kov-js-opt', group).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var sel = group.querySelector('[data-opt-sel="' + pos + '"]');
        if (sel) sel.textContent = btn.getAttribute('data-value');
        apply(findVariant(selectedValues()));
      });
    });
  }

  /* ---------- qty stepper ---------- */
  function initQty(pdp) {
    var input = $('#kov-qty', pdp);
    if (!input) return;
    var dec = $('.kov-js-qty-dec', pdp), inc = $('.kov-js-qty-inc', pdp);
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  }

  /* ---------- buy now (add then checkout) ---------- */
  function initBuyNow(pdp) {
    var btn = $('.kov-js-buynow', pdp);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var id = ($('#kov-variant-id', pdp) || {}).value;
      var qty = parseInt(($('#kov-qty', pdp) || {}).value, 10) || 1;
      if (!id || btn.disabled) return;
      btn.disabled = true; btn.textContent = 'One moment…';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      }).then(function () { window.location.href = ROOT + 'checkout'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Buy now'; });
    });
  }

  /* ---------- wishlist (visual) ---------- */
  function initWish(pdp) {
    $$('.kov-js-wish', pdp).forEach(function (b) {
      b.addEventListener('click', function () { $$('.kov-js-wish', pdp).forEach(function (x) { x.classList.toggle('is-active'); }); });
    });
  }

  /* ---------- delivery countdown ---------- */
  function initCountdown(pdp) {
    var box = $('.kov-deliverybox[data-cutoff]', pdp);
    if (!box) return;
    var out = $('.kov-countdown', box);
    var cutoff = parseInt(box.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoff)) cutoff = 23;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var target = new Date(now); target.setHours(cutoff, 0, 0, 0);
      if (target <= now) { target.setDate(target.getDate() + 1); }
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
      if (out) out.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    if (box._kovT) clearInterval(box._kovT);
    box._kovT = setInterval(tick, 1000);
  }

  /* ---------- collection filters ---------- */
  function initFilters() {
    var form = $('#kov-coll-filters');
    if (form) {
      $$('.kov-js-autosubmit').forEach(function (el) {
        el.addEventListener('change', function () {
          // drop empty number inputs so they don't pollute the URL
          $$('.kov-js-autosubmit').forEach(function (x) { if (x.type === 'number' && x.value === '') x.disabled = true; });
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      });
    }
    var toggle = $('.kov-js-filter-toggle');
    if (toggle) toggle.addEventListener('click', function () {
      var f = $('.kov-filters'); if (f) f.classList.toggle('is-open');
    });
  }

  function initPDP() {
    var pdp = $('#kov-pdp');
    if (pdp) { initGallery(pdp); initVariants(pdp); initQty(pdp); initBuyNow(pdp); initWish(pdp); initCountdown(pdp); }
    initFilters();
  }

  /* ---------- quick-add on product cards (only when the Kovosis cart drawer is absent) ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target && e.target.closest ? e.target.closest('.kov-js-add') : null;
    if (!add) return;
    if (document.getElementById('kov-cart-drawer')) return; // kovosis.js drawer handles it
    e.preventDefault();
    var id = add.getAttribute('data-variant-id');
    if (!id) return;
    add.disabled = true;
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function () { window.location.href = ROOT + 'cart'; })
      .catch(function () { add.disabled = false; });
  });

  if (document.readyState !== 'loading') initPDP();
  else document.addEventListener('DOMContentLoaded', initPDP);
  document.addEventListener('shopify:section:load', initPDP);
})();
